import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl, defineMessages} from 'react-intl';

import FormattedLink from '@stubhub/react-formatted-link';

import EntityList from '../react-entity-list';

import './index.scss';

const messages = defineMessages({
  viewAllEventsText: {
    id: 'City.venueCard.events.viewAll',
    defaultMessage: 'View all',
    description: 'View all events in this venue',
  },
});

class VenueCard extends Component {
  getVenueAddress() {
    const {address} = this.props;
    const {address1, postalCode, city, state} = address;

    return `${address1}, ${city}, ${postalCode || /* istanbul ignore next */ state}`;
  }

  render() {
    const {events, screenSize, id, name, address, intl, enableSubGenreModuleDesktop, isRedirectModalEnabled} =
      this.props;

    return (
      <div className="VenueCard">
        <div className="VenueHeader">
          <div className="VenueInfo">
            <h3 className={`VenueName ${enableSubGenreModuleDesktop ? 'VenueName__Standard' : ''}`}>
              {
                /* istanbul ignore next */ name && address.webURI ? (
                  <FormattedLink target="_blank" href={`/${address.webURI}`} className="VenueLink">
                    {name}
                  </FormattedLink>
                ) : (
                  name
                )
              }
            </h3>
            <section className="VenueAddress">{this.getVenueAddress()}</section>
          </div>
          <div className="Venue--ViewAll">
            <FormattedLink className="ViewAll" href={`/venue/${id}`} target="_blank">
              {intl.formatMessage(messages.viewAllEventsText)}&nbsp;
            </FormattedLink>
            <span className="sh-iconset sh-iconset-chevron right-arrow" />
          </div>
        </div>

        <div className="VenueEvents">
          <EntityList
            screenSize={screenSize}
            noFetch
            entityData={events}
            type="event"
            title={name}
            totalCount={events.length}
            useCarousel
            initialSliderFrameWidth={10000}
            hideEventVenue={enableSubGenreModuleDesktop}
            isRedirectModalEnabled={isRedirectModalEnabled}
          />
        </div>
      </div>
    );
  }
}

VenueCard.propTypes = {
  // Venue info from API call.
  id: PropTypes.number,
  name: PropTypes.string,
  address: PropTypes.object,
  // Venue related events from reco API.
  events: PropTypes.array,
  screenSize: PropTypes.string,
  enableSubGenreModuleDesktop: PropTypes.bool,
  intl: PropTypes.object,

  /** Is redirection modal enabled? */
  isRedirectModalEnabled: PropTypes.bool,
};

export default injectIntl(VenueCard);
